import { Grid, Box } from '@mui/material'
import { Brand, Position, State } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { GloveEmbroideries } from 'src/features/simulationConfirm/Components/GloveEmbroideries'
import { ItemCell } from 'src/Components/Domain/ItemCell'
import { muiGrey } from 'src/style/muiTheme'
import { AdditionalEmbroideryConfirm } from './AdditionalEmbroideryConfirm'
import { genBaseCells } from 'src/logic/simulationSpecification/glove'
import { genColorCells } from 'src/logic/simulationSpecification/glove'

export const cellColor = (cellValue: string) => (cellValue === 'unselected' ? 'red' : muiGrey)

type Props = {
  state: State
  brand: Brand
  position: Position
  shouldTranslate: boolean
}

export const SimulationContent: React.FC<Props> = ({ state, brand, position, shouldTranslate }) => {
  const { t, language } = useLocale()
  /**
   * 日本人が発注画面を触る想定ならば、基本項目とカラー項目のセルを翻訳する必要がある。
   * ただし、韓国人が発注画面を触る想定ならば、基本項目とカラー項目のセルは翻訳しなくて良さそう。
   */
  const baseCells = genBaseCells(state, brand, position, t, language)
  const colorCells = genColorCells(position, state, brand, t, language)
  const baseCellCount = baseCells.length
  const colorCellCount = colorCells.length
  const baseAndColorCellCount = baseCellCount + colorCellCount

  // ONLY FOR YELLSTORY
  const isYellStory = brand === 'yellStory'
  const indexOfYsrOriginalEmbroidery = isYellStory ? 1 : 0
  const ysrOriginalLogoIndex = baseAndColorCellCount + indexOfYsrOriginalEmbroidery
  const ysrDirectLogo1PositionIndex = ysrOriginalLogoIndex + 1
  const ysrDirectLogo1MainColorIndex = ysrDirectLogo1PositionIndex + (state.ysrDirectLogo1Position?.value !== 'none' ? 1 : 0)
  const ysrDirectLogo1EdgeColorIndex = ysrDirectLogo1PositionIndex + (state.ysrDirectLogo1Position?.value !== 'none' ? 2 : 0)
  const ysrDirectLogo2PositionIndex = ysrDirectLogo1EdgeColorIndex + 1
  const ysrDirectLogo2ColorIndex = ysrDirectLogo2PositionIndex + (state.ysrDirectLogo2Position?.value !== 'none' ? 1 : 0)

  return (
    <Grid container>
      <Grid item xs={12} sm={4}>
        <Box pt={2}>
          <Box fontWeight="bold" fontSize="16px" color={muiGrey}>
            {t.BASE_ITEMS}
          </Box>
          {baseCells?.map((cell, i) => <ItemCell key={cell.head} itemIndex={i + 1} cell={cell} color={cellColor(cell.value)} />)}
        </Box>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Box pt={2}>
          <Box fontWeight="bold" fontSize="16px" color={muiGrey}>
            {t.COLOR_ITEMS}
          </Box>
          {colorCells?.map((cell, i) => <ItemCell key={cell.head} itemIndex={i + baseCellCount + 1} cell={cell} color={cellColor(cell.value)} />)}
        </Box>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Box pt={2}>
          <AdditionalEmbroideryConfirm
            isDisplay={isYellStory}
            index={ysrOriginalLogoIndex}
            header={t.ORIGINAL_EMBROIDERY}
            targetState={state.ysrOriginalEmbroidery}
          />
          <AdditionalEmbroideryConfirm
            isDisplay={isYellStory}
            index={ysrDirectLogo1PositionIndex}
            header={t.DIRECT_LOGO_EMBROIDERY_1}
            targetState={state.ysrDirectLogo1Position}
          />
          <AdditionalEmbroideryConfirm
            isDisplay={isYellStory && !['unselected', 'none'].includes(state.ysrDirectLogo1Position?.value)}
            index={ysrDirectLogo1MainColorIndex}
            item={t.DIRECT_LOGO_EMBROIDERY_1_MAIN_COLOR}
            targetState={state.ysrDirectLogo1MainColor}
          />
          <AdditionalEmbroideryConfirm
            isDisplay={isYellStory && !['unselected', 'none'].includes(state.ysrDirectLogo1Position?.value)}
            index={ysrDirectLogo1EdgeColorIndex}
            item={t.DIRECT_LOGO_EMBROIDERY_1_EDGE_COLOR}
            targetState={state.ysrDirectLogo1EdgeColor}
          />
          <AdditionalEmbroideryConfirm
            isDisplay={isYellStory}
            index={ysrDirectLogo2PositionIndex}
            header={t.DIRECT_LOGO_EMBROIDERY_2}
            targetState={state.ysrDirectLogo2Position}
          />
          <AdditionalEmbroideryConfirm
            isDisplay={isYellStory && !['unselected', 'none'].includes(state.ysrDirectLogo2Position?.value)}
            index={ysrDirectLogo2ColorIndex}
            item={t.DIRECT_LOGO_EMBROIDERY_2_COLOR}
            targetState={state.ysrDirectLogo2Color}
          />
          <Box mt={2}>
            <GloveEmbroideries state={state} previousIndex={(isYellStory ? ysrDirectLogo2ColorIndex : 0) + 1} shouldTranslate={shouldTranslate} />
          </Box>
        </Box>
      </Grid>
    </Grid>
  )
}
